const download = () => {
  const downloads = document.querySelectorAll('[data-download-collection]');
  if (downloads.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < downloads.length; i++) {
      downloads[i].addEventListener('click', () => {
        const urls = JSON.parse(
          downloads[i].getAttribute('data-download-collection'),
        );

        // eslint-disable-next-line no-var,vars-on-top,no-use-before-define
        const interval = setInterval(generateDownload, 300, urls);

        // eslint-disable-next-line no-inner-declarations,no-shadow
        function generateDownload(urls) {
          const url = urls.pop();
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('download', '');
          a.setAttribute('target', '_blank');
          a.click();

          if (urls.length === 0) {
            clearInterval(interval);
          }
        }
      });
    }
  }
};

download();
